<template>
  <lazy-div :load="doInit">
    <v-toolbar dense color="grey lighten-3" flat>
      <v-btn text icon color="green">
        <v-icon @click="$router.push('general')">mdi-keyboard-backspace</v-icon>
      </v-btn>
      <v-toolbar-title class="toolbar-title-custom">Scheme Code: {{ scheme }}</v-toolbar-title>
    </v-toolbar>
    <v-card>
      <v-tabs v-model="tabValue" slider-color="primary">
        <v-tab @click="resetTab">Listing</v-tab>
        <v-tab v-show="review">Action</v-tab>
        <v-tab-item>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-toolbar-title>Permitted Scheme per Policy Type</v-toolbar-title>
          </v-toolbar>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class=" mr-2" @click="doNew">
              New Permitted Policy Type
              <v-icon right>mdi-plus</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-title>
            <v-flex xs12>
              <v-subheader class="queryLabel">{{ labels.scheme }}</v-subheader>
              <div class="queryValue">{{ scheme }}</div>
            </v-flex>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            v-bind:options.sync="pagination"
            item-key="name"
            :loading="loading"
            :no-data-text="noDataText"
            :custom-filter="customSearch"
          >
            <template v-slot:item="row"
              ><tr>
                <td class="text-xs-left">{{ row.item.polType }}</td>
                <td class="text-xs-left">{{ row.item.polTypeDesc }}</td>
                <td class="text-xs-left">{{ row.item.effDate }}</td>
                <td class="text-xs-left">{{ row.item.expDate }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
                </td></tr
            ></template>
          </v-data-table>
          <confirm v-model="promptRemove" @ok="doRemove">
            Are you sure you want to delete the selected record? ({{ selectedPolTypeScheme.scheme + ', ' + selectedPolTypeScheme.polType }})
          </confirm>
        </v-tab-item>
        <v-tab-item v-show="review">
          <poltypescheme-review :scheme="scheme" :polType="polType" @close="resetTab"></poltypescheme-review>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </lazy-div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import PoltypeschemeReview from './PolTypeSchemeReview'

export default {
  props: ['scheme'],
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Policy Type', align: 'left', value: 'polType' },
        { text: 'Policy Type Description', value: 'polTypeDesc' },
        { text: 'Effective Date', value: 'effDate' },
        { text: 'Expiry Date', value: 'expDate' },
        TableConst.tableActionHeader
      ],
      labels: {
        scheme: 'Scheme',
        polType: 'Policy Type'
      },
      filters: {
        polType: null
      },
      selectedPolTypeScheme: {},
      tabValue: 0,
      review: false,
      newPolTypeScheme: false,
      polTypeList: [],
      loading: false,
      promptRemove: false,
      polType: null,
      totalItems: 0,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  async mounted() {
    if (this.$store.state.pkgParam.polTypeScheme.init !== 1) {
      await this.$store.dispatch('polTypeSchemeInit')
    }
    this.doInit()
    this.getPolTypeList()
  },
  computed: {
    menu() {
      return this.$store.state.pkgParam.polTypeScheme.menu
    }
  },
  methods: {
    async doInit() {
      const apiURI = this.menu.getPolTypeSchemeListByScheme
      if (apiURI) {
        this.loading = true
        let expand = { scheme: this.scheme }
        const result = await this.$http.get(expandURI(apiURI, expand))
        if (result.data) {
          const { data } = result.data
          this.items = []
          if (data) {
            data.map((polTypeSchemeList) => {
              const convertList = {
                scheme: polTypeSchemeList.scheme,
                polType: polTypeSchemeList.polType,
                polTypeDesc: polTypeSchemeList.polTypeDesc,
                effDate: polTypeSchemeList.effDate,
                expDate: polTypeSchemeList.expDate
              }
              this.items.push(convertList)
            })
          }
        }
        this.loading = false
      } else {
        this.items = []
      }
    },
    async getPolTypeList() {
      const apiURI = this.menu.getPolTypeList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        this.polTypeList = []
        if (data) {
          this.polTypeList = data.polTypeList
        }
      }
    },
    doNew() {
      this.polType = 'new'
      this.review = true
      this.tabValue = 1
    },
    doReview(data) {
      this.polType = data.polType
      this.review = true
      this.tabValue = 1
    },
    doPromptRemove(data) {
      this.resetMessages()
      this.selectedPolTypeScheme = data
      this.promptRemove = true
    },
    async doRemove() {
      const apiURI = this.menu.deletePolTypeScheme
      if (apiURI) {
        const expand = this.selectedPolTypeScheme
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(false)
          })
          .catch((err) => {
            const { data } = err.response
            this.message(data)
          })
      }
    },
    resetTab() {
      this.tabValue = 0
      this.doInit()
      this.review = false
      this.polTypeScheme = false
    }
  },
  mixins: [TableConst.default, MessageMixin],
  components: {
    PoltypeschemeReview
  }
}
</script>
